<template>
	<ForgotPasswordTokenForm />
</template>

<script>
import { useMeta } from 'vue-meta';
import { useI18n } from 'vue-i18n/index';
import ForgotPasswordTokenForm from '@/components/auth/forms/ForgotPasswordTokenForm.vue';

export default {
	name: 'ForgotPasswordToken',
	components: {
		ForgotPasswordTokenForm
	},
	setup () {
		const { t } = useI18n();
		useMeta({ title: t('pages.auth.forgotPassword.pageTitle', { appName: 'Clarity' }) });
	}
};
</script>
